'use client';

import styled from 'styled-components';

const PaginationStyle = styled.div`
  margin-top: 40px;
    .pagination-links {
        display: flex;
        justify-content: space-between;
        margin-left: auto;
        margin-right: auto;
        max-width: 1024px;
    }

  button,
  a {
    background: transparent;
    padding: 10px 18px;
    font-size: 16px;
    cursor: pointer;

    color: #333;
    border: 1px solid #ddd;
    border-radius: 6px;
    transition: all 0.2s ease;

    &:hover {
      background: #eee;
      border-color: #ccc;
    }
  }
`;

export default PaginationStyle;
